export const getErrorMessage = (error: unknown, fallback = 'Something went wrong'): string => {
  if (typeof error === 'object' && error !== null) {
    // @ts-expect-error - narrowing an unknown error to an axios-like response shape
    const errors = error.response?.data?.errors;
    if (Array.isArray(errors) && errors.length > 0) {
      return errors[0].message || fallback;
    }
    // @ts-expect-error - narrowing an unknown error to an axios-like response shape
    const message = error.response?.data?.error || error.response?.data?.message;
    if (message) return message;
  }
  if (error instanceof Error) return error.message;
  return fallback;
};
